import { composeIO } from 'react-compose-io'
import { modalValidacaoPlanilhaRegularizacaoIO } from './ModalValidacaoPlanilhaRegularizacao.IO'
import { ModalValidacaoPlanilhaRegularizacaoView } from './ModalValidacaoPlanilhaRegularizacao.View'

export const ModalValidacaoPlanilhaRegularizacao = composeIO(ModalValidacaoPlanilhaRegularizacaoView, modalValidacaoPlanilhaRegularizacaoIO)
